import Link from "./Link";
import type { LinkProps } from "./Link.d";

export { Link, LinkProps };
